
























































































import Vue, { PropType } from 'vue';
// import { Buyer } from '@/modules/buyer/buyer';
// import { Company } from '@/modules/buyer/company';
import {
  Buyer,
  BuyerCompany as Company,
} from 'mostra';

export default Vue.extend({
  name: 'GUserInfo',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    buyer: {
      type: Object as PropType<Buyer>,
      required: true,
    },
    company: {
      type: Object as PropType<Company>,
      required: true,
    },
    // caution: {
    //   type: String as PropType<string>,
    //   default: 'jpg/pngの正方形のデータを登録してください。Please register jpg/png square data.',
    // },
    underline: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    showCompanyName: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    showDragOver: {
      type: Boolean,
      default: false,
    },
  },
});
